  <template>
  <div class="boma-hero overlay">
   <div class="hero-inner">
    <div class="top-with-navigation">
       <div class="logo">
        <div class="text">
          <p>
            Under the <br class="_rm"/>
            aegis of
          </p>
        </div>
        <div class="image">
          <img src="../../assets/boma/auweblogo-en.svg" alt="">
        </div>
       </div>
       <!-- navigation content -->
        <div id="myNav"  class="overlay-content">
            <button @click="closeNav" class="closebtn">&times;</button>
            <div class="navbar">
                <a href="/">Home</a>
                <a href="/Boma2022/agenda">Agenda</a>
                <a href="/Boma2022/contact">Contact</a>
                <a href="/boma2022/register">Register</a>
            </div>
        </div>
        <!-- toggle button -->
        <button id="nav_toggler" @click="openModal">
          <i class="fas fa-bars"></i>
        </button>
    </div>

    <div class="hero-text">
      <div class="row">
        <div class="col-md-5">
          <div class="main-section">
            <div class="boma-head">
              <h2>
                Contact Us
              </h2>
            </div>
            <div class="___privacy">
              <div>
                <p>
                Boma of Africa | Afrochampions © 2022. <br/>
                All Rights Reserved
              </p>
              <p>
                Terms & Conditions. Privacy Policy
              </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-7">
         <div class="boma-form-container">

          <form @submit="contactUs">
            <div class="row">
              <div class="col">
                <label for="name">Name</label>
                <input id="name" type="text" v-model="name" required class="form-input" placeholder="John Doe">
              </div>
              <div class="col">
                <label for="email">Email</label>
                <input id="email" type="email" required v-model="email" class="form-input" placeholder="example@email.com">
              </div>
              <div class="col-12">
                <label for="subject">Organization</label>
                <input id="subject" v-model="organization" type="text" required class="form-input" placeholder="Mpedigre">

            </div>
            <div class="col-12">
                <label for="subject">Message</label>
                <textarea id="subject" v-model="message" rows="4" type="text" required class="form-input" placeholder="Enter your message">
                </textarea>
            </div>
            <div class="col-md-12">
              <button id="submit">
                Submit
              </button>
            </div>
            </div>
          </form>
         </div>
         <!--  -->
         <div class="___privacy_sm">
            <div>
              <p>
              Boma of Africa | Afrochampions © 2022.
              <br> All Rights Reserved
            </p>
            <p>
              Terms & Conditions. Privacy Policy
            </p>
            </div>
          </div>
        </div>
      </div>
   </div>

   </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data(){
    return {
      email:null,
      message:null,
      organization:null,
      name:null
    }
  },
  methods: {
    openModal() {
      document.getElementById("myNav").style.display = "block";
    },
    closeNav(){
      console.log('here i am')
      document.getElementById("myNav").style.display = "none";
    },
    contactUs() {
    const data = {
        name:this.name,
        organization:this.organization,
        message:this.message,
        email:this.email
    }
    axios.post(`https://main.afcfta.app/api/contact-form`, data)
      .then(response => {
          if(response) {
              this.toast({
                  message:'Your message has been sent successfully, Our team will get back to you soon.',
                  type:'success'
              })
          }
          this.email = null
          this.organization = null
          this.name = null
          this.message = null
      }).catch(err => {
          if(err?.response?.data == undefined) {
              this.toast({
                  message:'Network error. Check your network connection and try again.'
              })
          }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.___privacy_sm{
  display: none;
}
  #submit{
    outline: none;
    border: none;
    background: #83BC3F;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 40px;
    text-align: center;
    color: #FFFFFF;
    width: 200px;
    max-width: 100%;
    height: 50px;
  }
  .boma-hero{
    width: 100vw;
    height: 100vh;
    background: #008a44;
    background-image: url('../../assets/boma/pattern.svg');
  }
  .hero-inner{
    padding-right: 10%;
    padding-left: 10%;
    height: 100vh;
    .top-with-navigation{
      display: flex;
      justify-content: space-between;
      .closebtn{
        display: none;
      }
     .logo{
        width: 114px;
        height: 168px;
        border-bottom-right-radius: 70px;
        border-bottom-left-radius: 70px;
        padding-top: 38px;
        padding-left: 24px;
        padding-right: 24px;
        background-color: #fff;
      .text{
        p{
          margin: 0px;
          padding: 0px;
          font-family: 'Montserrat';
          font-style: normal;
          font-weight: 400;
          font-size: 13px;
          line-height: 15px;
          text-align: center;
        }
      }
     }
    //  TOP NAVIGATION
     .overlay-content{
      .navbar{
        padding-top: 50px;
        display: block;
        a{
          font-family: 'Montserrat';
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 20px;
          color: #FFFFFF;
          &:not(:last-of-type) {
            margin-right: 22px;
          }
        }
      }
     }
     // NAV TOGGLER
     #nav_toggler{
      display: none;
     }
    }
    .hero-text{
      margin-top: 50px;
      .main-section{
        display: flex;
        flex-direction: column;
        height: 530px;
        .boma-head {
          h2{
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 900;
            font-size: 64px;
            line-height: 78px;
            color:#FFFFFF;
          }
        }
        .___privacy{
          background:transparent;
          margin-top: 370px;
          div{
            p{
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 700;
            font-size: 16px;
            line-height: 20px;
            color: #FFFFFF;
          }
          }
        }
      }
      .boma-form-container{
        background: #FFFFFF;
        padding: 5%;
      }
      form{
        label{
          display: block;
          font-family: 'Montserrat';
          font-style: normal;
          font-weight: 700;
          font-size: 18px;
          line-height: 26px;
          color: #000000;
          margin-bottom: .5em;
        }
        input, textarea{
          background: #F5F5F5;
          border-radius: 5px;
          width: 100%;
          outline:none;
          margin-bottom: 1em;
          padding: 20px 32px;
          border: none;
        }
        input {
          height: 60px;
        }
      }
    }
  }
  // responsiveness
  @media screen and (max-width: 768px) {
    .___privacy{
      display: none;
    }
    ._rm{
      display: none;
    }
    .boma-hero{
      height: 100%;
    }
    .hero-inner{
      padding-right: 10%;
      padding-left: 10%;
      height: 100%;
    .top-with-navigation{
      .logo{
        background-color: #fff;
        width: 80px;
        height: 120px;
        border-bottom-right-radius: 70px;
        border-bottom-left-radius: 70px;
        padding: 10px;
        padding-top: 20px;
      }
      #nav_toggler{
        display: block;
        width: 50px;
        height: 50px;
        margin-top: 50px;
        background-color: transparent;
        color: #fff;
        font-size: 2.2em;
        outline: none;
        border: none;
      }
      .closebtn {
        display: block;
        font-size: 60px;
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: transparent;
        outline: none;
        border:none;
        color: #818181;
        float:right;
        &:hover,&:focus {
            color: #f1f1f1;
          }
      }
      // navigation content
      //  TOP NAVIGATION
    .overlay-content {
      height: 100%;
      width: 100%;
      position: fixed;
      display: none;
      z-index: 1;
      top: 0;
      left: 0;
      background-color: rgb(0,0,0);
      background-color: rgba(0,0,0, 0.9);
      overflow-x: hidden;
      transition: 0.5s;
      .navbar {
          width: 100%;
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-top: 0px;
          height: calc(100% - 50px);
        a {
          padding: 8px;
          text-decoration: none;
          font-size: 36px;
          color: #818181;
          display: block;
          transition: 0.3s;
          text-align: center;
          
          &:hover,&:focus {
            color: #f1f1f1;
          }
          &:not(:last-of-type) {
            margin-right: 0px;
            margin-bottom: 25px;
          }
        }
      }
    }
    }
    .hero-text{
      margin-top: 50px;
    }
    }

    .main-section{
        height: 100px!important;
        .boma-head {
          h2{
            font-size: 38px!important;
          }
        }
    }
    input, textarea{
      padding: 10px 12px!important;
    }
    input{
      height: 50px;
    }
    #submit{
      width: 100%;
      margin-bottom: 20px;
    }
    .___privacy_sm{
          background:transparent;
          margin-top: 100px;
          padding-bottom: 20px;
          display: block;
          div{
            p{
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 700;
            font-size: 16px;
            line-height: 20px;
            color: #FFFFFF;
            text-align: center;
          }
          }
        }
  }

  // smaller screens
  @media screen and (max-height: 450px) {
  .navbar a {font-size: 20px}
   .top-with-navigatio .closebtn {
    font-size: 40px;
    }
}
</style>